import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import KiloNewton from "../../../components/Math/Units/Metric/KiloNewton";
import Metre from "../../../components/Math/Units/Metric/Metre";
import { NumberFormatText } from "../../../components/NumberFormatText";
import { selectAeussere } from "../../../store/slices/aeussereSlice.js";
import KiloNewtonDividedByMetreSquared from "../../../components/Math/Units/Metric/KiloNewtonDividedByMetreSquared";

function DruckpfahlgruppeTable() {
  const { t } = useTranslation("translation");
  const aussereData = useSelector(selectAeussere);
  //HOTFIX: if there is no dGruppe.schichtenCalculated
  const areCalculatedLayersPresent =
    aussereData?.dGruppe?.schichtenCalculated !== undefined ? true : false;
  return (
    <Row>
      <Col md={8}>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">
                <p>{t("aeussre.tableLayer")}</p>
                <p>{t("aeussre.tableLayerUnit")}</p>
              </th>
              <th scope="col">
                <p>{t("aeussre.tableFrom")}</p>
                <p>
                  [<Metre />]
                </p>
              </th>
              <th scope="col">
                <p>{t("aeussre.tableTo")}</p>
                <p>
                  [<Metre />]
                </p>
              </th>
              <th scope="col">
                <p>
                  q<sub>s,k</sub>
                </p>
                <p>
                  [<KiloNewtonDividedByMetreSquared />]
                </p>
              </th>
              <th scope="col">
                <p>
                  R<sub>d,i</sub>
                </p>
                <p>[kN/m]</p>
              </th>
              <th scope="col">
                <p>
                  L<sub>i,&beta;</sub>
                </p>
                <p>
                  [<Metre />]
                </p>
              </th>
              <th scope="col">
                <p>
                  R<sub>s,d,i</sub>
                </p>
                <p>
                  [<KiloNewton />]
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            {areCalculatedLayersPresent &&
              aussereData?.schichtenInput.map((row, index) => {
                return <AussereTableRow key={index} index={index} />;
              })}

            {/* Results: */}
            <tr>
              {/* 5x Empty */}
              <td colSpan="5" />
              <td>
                <span className="input">
                  <NumberFormatText value={aussereData?.dGruppe?.lreq} decimalScale={2} />
                </span>
              </td>
              <td>
                <span className="input">
                  <NumberFormatText value={aussereData?.dGruppe?.sumRsdi} decimalScale={0} />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </Col>
    </Row>
  );
}

export default DruckpfahlgruppeTable;

function AussereTableRow({ index }) {
  const schichtenInput = useSelector((state) => state.aeussere.schichtenInput[index]);
  const schichtenCalculated = useSelector(
    (state) => state.aeussere.dGruppe?.schichtenCalculated[index]
  );

  return (
    <tr>
      <td>
        <span name="schichtName" className="input">
          {schichtenInput?.schichtName}
        </span>
      </td>
      <td>
        <span name="von" className="input">
          <NumberFormatText value={schichtenInput?.von} decimalScale={2} />
        </span>
      </td>
      <td>
        <span name="bis" className="input">
          <NumberFormatText value={schichtenInput?.bis} decimalScale={2} prefix={"INF"} />
        </span>
      </td>
      <td>
        <span name="qski" className="input">
          <NumberFormatText value={schichtenInput?.qski} />
        </span>
      </td>
      <td>
        <span name="rdi" className="input">
          <NumberFormatText value={schichtenCalculated?.rdi} decimalScale={2} />
        </span>
      </td>
      <td>
        <span name="liZeta" className="input">
          <NumberFormatText value={schichtenCalculated?.liZeta} decimalScale={2} />
        </span>
      </td>
      <td>
        <span name="rsdi" className="input">
          <NumberFormatText value={schichtenCalculated?.rsdi} decimalScale={0} />
        </span>
      </td>
    </tr>
  );
}
